import ScaleSubscriptionsPage from '../pages/admin/subscriptions/scale/scale-subscriptions-page'
export default ScaleSubscriptionsPage
